import apply from '../../_helpers/apply.js';
import forEach from '../../_helpers/foreach.js';
import MatreshkaArray from '../index.js';
// the method works just like Array.prototype.concat but
// - flattens both Array and Matreshka.Array
// - returns Matreshka.Array
export default function concat() {
  for (var _len = arguments.length, _items = new Array(_len), _key = 0; _key < _len; _key++) {
    _items[_key] = arguments[_key];
  }
  var args = Array(arguments.length);
  // convert all instances of Matreshka.Array to Array
  forEach(arguments, function (arg, index) {
    if (arg && typeof arg === 'object' && arg.isMatreshkaArray) {
      args[index] = arg.toJSON(false);
    } else {
      args[index] = arg;
    }
  });
  // call original concat method
  var nativeCallResult = apply(Array.prototype.concat, this.toJSON(false), args);
  // convert returned value to Matreshka.Array
  var result = new MatreshkaArray();
  forEach(nativeCallResult, function (item, index) {
    result[index] = item;
  });
  result.length = nativeCallResult.length;
  return result;
}